import { Card, Col, Container, Row } from "react-bootstrap";
import { NavLink } from "react-router-dom";

const Application = () => {
  return (
    <>
      <div className="py-2">
        <Container fluid>
          <Row>
            <Col xxl={3} xl={4} lg={6} md={6} sm={6}>
              <NavLink to="/home/vaults" style={{textDecoration: "none"}}>
                <Card className="shadow-sm text-center p-3 CP bg-light app-card" title="Vault Management | Password Manager">
                  <Card.Body>
                    <img src={`https://password-super.s3.ap-south-1.amazonaws.com/icons/wordpress.png`} alt="Vault Management" style={{height: 60}} />
                    <Card.Title className="fw-bold mt-3 m-0" style={{fontSize: 16}}>Vault Management</Card.Title>
                    <Card.Text className="text-muted" style={{fontSize: 13}}>Password Manager</Card.Text>
                  </Card.Body>
                </Card>
              </NavLink>
            </Col>
            <Col xxl={3} xl={4} lg={6} md={6} sm={6}>
              <NavLink to="/home/sitePilot" style={{textDecoration: "none"}}>
                <Card className="shadow-sm text-center p-3 CP bg-light app-card" title="Site Pilot Management | Site Manage">
                  <Card.Body>
                    <img src={`https://password-super.s3.ap-south-1.amazonaws.com/icons/wordpress.png`} alt="Site Pilot Management" style={{height: 60}} />
                    <Card.Title className="fw-bold mt-3 m-0" style={{fontSize: 16}}>Site Pilot Management</Card.Title>
                    <Card.Text className="text-muted" style={{fontSize: 13}}>Messaging and SEO</Card.Text>
                  </Card.Body>
                </Card>
              </NavLink>
            </Col>
            <Col xxl={3} xl={4} lg={6} md={6} sm={6}>
              <NavLink to="/home/workBridge" style={{textDecoration: "none"}}>
                <Card className="shadow-sm text-center p-3 CP bg-light app-card" title="Work Bridge | People Connect">
                  <Card.Body>
                    <img src={`https://password-super.s3.ap-south-1.amazonaws.com/icons/wordpress.png`} alt="Work Bridge" style={{height: 60}} />
                    <Card.Title className="fw-bold mt-3 m-0" style={{fontSize: 16}}>Work Bridge</Card.Title>
                    <Card.Text className="text-muted" style={{fontSize: 13}}>Organization Work</Card.Text>
                  </Card.Body>
                </Card>
              </NavLink>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Application;
